export default __webpack_public_path__ + "static/media/Banner_image_prison_break_small.97a8a7d3.jpg";